import React, { Fragment } from "react";
import ResponsiveWrapper from "../_responsive-wrapper";
import Link from "@helpers/link";

const Breadcrumbs = ({ items }) => {
    const mobileVisibleItems = items.length <= 2 ? items : [
        // eslint-disable-next-line no-script-url
        { title: "...", url: "#" },
        items[items.length - 2],
        items[items.length - 1],
    ];

    const outputItems = (_items) => _items.map((item, index) => (
        <Fragment key={item.title}>
            {index > 0 && <div className="breadcrumbs__divider"/>}
            <div className="breadcrumbs__link">
                <Link to={item.url} onClick={(e) => item?.onClick(e, item)}>{item.title}</Link>
            </div>
        </Fragment>
    ));

    return (
        <ResponsiveWrapper className="breadcrumbs">
            <div className="breadcrumbs__wrapper">
                <div className="breadcrumbs__desktop">
                    {outputItems(items)}
                </div>
                {/* Mobile view */}
                <div className="breadcrumbs__mobile">
                    {outputItems(mobileVisibleItems)}
                </div>
            </div>
        </ResponsiveWrapper>
    );
};

export default Breadcrumbs;
